import { render, staticRenderFns } from "./LabelList.vue?vue&type=template&id=554b5de5&scoped=true&"
import script from "./LabelList.vue?vue&type=script&lang=js&"
export * from "./LabelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554b5de5",
  null
  
)

export default component.exports